import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import SmartBanner from "react-smartbanner"
import "react-smartbanner/dist/main.css"

const AppBanner = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          appTitle
        }
      }
    }
  `)

  const { appTitle } = data.site.siteMetadata

  return (
    <SmartBanner
      title={appTitle}
      daysHidden={1}
      daysReminder={1}
      position="top"
    />
  )
}
export default AppBanner
